import './story-hero.scss';

import StoryHero from './StoryHero';

export default StoryHero;
